import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {CommonModule} from "@angular/common";

@Component({
    selector: 'db-loading-circular-spinner',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './loading-circular-spinner.component.html',
    styleUrls: ['./loading-circular-spinner.component.scss'],
    standalone: true,
    imports: [CommonModule]
})
export class LoadingCircularSpinnerComponent {

  @Input() size: string = 'sm';
  @Input() newMode = false;
  @Input() color: string = 'white';
  @Input() default?: boolean = true;
}
